import AudioVisualizer from "./audioVisualizer";
import Speech from "speak-tts";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useStores } from "../../store/index";
import useSpeechToText from "react-hook-speech-to-text";
import { FiActivity, FiPauseCircle, FiPlayCircle } from "react-icons/fi";
import {
  AiOutlineAudio,
  AiOutlineDashboard,
  AiOutlineSound,
} from "react-icons/ai";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import { audioOptions, azureSpeechKey } from "../../helpers/constantVariables";
import { removeCharInSetence } from "../../services/reusable";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { IoClose, IoVideocam, IoVideocamOff } from "react-icons/io5";
import { BsMicFill, BsMicMuteFill } from "react-icons/bs";
import { Observer } from "mobx-react";
import { FaCheck } from "react-icons/fa";
import { RadioGroup } from "@radix-ui/themes";
import { collectAndStoreMetrics } from "../../services/systemMetrics";

import video from "../../assests/video.mp4";
import video2 from "../../assests/video3.mp4";
import clipboardVideo from "../../assests/clipboard.mp4";
import clipboardVideo2 from "../../assests/clipboard2.mp4";

const SPEECH_KEY = azureSpeechKey;
const REACT_APP_SPEECH_REGION =
  process.env.REACT_APP_SPEECH_REGION ?? "centralindia";
console.log("this is the region", REACT_APP_SPEECH_REGION);

const micTestReference = "The quick brown fox jumps over the lazy dog.";

function isTranscriptMatch(transcript, reference) {
  const normalize = (str) =>
    str
      .replace(/[.,!?]/g, "")
      .toLowerCase()
      .trim();
  return normalize(transcript) === normalize(reference);
}

function getMicTestProgress(reference, transcript) {
  const refWords = reference.split(" ");
  const spokenWords = transcript.split(" ");

  // Create a more flexible matching that can handle partial matches
  const matchedWords = new Set();

  // First pass: find exact matches in order
  let spokenIndex = 0;
  for (
    let i = 0;
    i < refWords.length && spokenIndex < spokenWords.length;
    i++
  ) {
    const refWord = refWords[i].replace(/[.,!?]/g, "").toLowerCase();
    const spokenWord = spokenWords[spokenIndex]
      .replace(/[.,!?]/g, "")
      .toLowerCase();

    if (refWord === spokenWord) {
      matchedWords.add(i);
      spokenIndex++;
    } else {
      // Look ahead in spoken words to find a match
      let found = false;
      for (let j = spokenIndex + 1; j < spokenWords.length; j++) {
        const nextSpokenWord = spokenWords[j]
          .replace(/[.,!?]/g, "")
          .toLowerCase();
        if (refWord === nextSpokenWord) {
          matchedWords.add(i);
          spokenIndex = j + 1;
          found = true;
          break;
        }
      }
      if (!found) {
        spokenIndex++;
      }
    }
  }

  return refWords.map((word, idx) => ({
    word,
    matched: matchedWords.has(idx),
  }));
}

function getMicTestMatchPercent(reference, transcript) {
  const refWords = reference.split(" ");
  const spokenWords = transcript.split(" ");

  // Use the same flexible matching logic
  const matchedWords = new Set();

  let spokenIndex = 0;
  for (
    let i = 0;
    i < refWords.length && spokenIndex < spokenWords.length;
    i++
  ) {
    const refWord = refWords[i].replace(/[.,!?]/g, "").toLowerCase();
    const spokenWord = spokenWords[spokenIndex]
      .replace(/[.,!?]/g, "")
      .toLowerCase();

    if (refWord === spokenWord) {
      matchedWords.add(i);
      spokenIndex++;
    } else {
      // Look ahead in spoken words to find a match
      let found = false;
      for (let j = spokenIndex + 1; j < spokenWords.length; j++) {
        const nextSpokenWord = spokenWords[j]
          .replace(/[.,!?]/g, "")
          .toLowerCase();
        if (refWord === nextSpokenWord) {
          matchedWords.add(i);
          spokenIndex = j + 1;
          found = true;
          break;
        }
      }
      if (!found) {
        spokenIndex++;
      }
    }
  }

  return (matchedWords.size / refWords.length) * 100;
}

export default function TestMedia({
  popUPInitialValue,
  handlePopUp,
  openingThroughSettings = false,
  handleTestCompleted,
}) {
  const [speaking, setSpeaking] = useState(false);
  const speech = new Speech();
  const { UserStore, PopupStore } = useStores();
  const [isUnmuted, setIsUnMuted] = useState(false);
  const videoRef = useRef(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [mobileView, setMobileView] = useState(false);
  const speechConfig = useRef(null);
  const audioConfig = useRef(null);
  const recognizer = useRef(null);
  const [isListening, setIsListening] = useState(false);
  const isListeningRef = useRef(isListening);
  const [transcriptArr, setTranscriptArr] = useState([]);
  const [playing, setPlaying] = useState(false);
  const { InterviewStore } = useStores();
  const [isChecked, setIsChecked] = useState(false);
  const [step, setStep] = useState(0); // 0: Welcome, 1: Camera, 2: Internet, 3: Speaker, 4: Mic
  const [maxStep, setMaxStep] = useState(0); // Track the furthest step reached
  const steps = [
    { label: "Welcome" },
    { label: "Camera" },
    { label: "Internet" },
    { label: "Speaker" },
    { label: "Mic" },
    { label: "Clipboard" },
    { label: "Summary" },
  ];
  const [cameraFeedback, setCameraFeedback] = useState(null); // null, 'yes', or 'no'
  const [speedHistory, setSpeedHistory] = useState([]); // For last 10 speed measurements
  const [speakerFeedback, setSpeakerFeedback] = useState(null); // null, 'yes', or 'no'
  const [speakerHeard, setSpeakerHeard] = useState(null); // null, 'yes', or 'no'
  const [speakerManualFeedback, setSpeakerManualFeedback] = useState(null); // null, 'yes', or 'no'
  const [internetFeedback, setInternetFeedback] = useState(null); // null, 'yes', or 'no'
  const [audioPlayed, setAudioPlayed] = useState(false); // Track if audio was played
  const [clipboardAccess, setClipboardAccess] = useState(false); // Track if clipboard access is granted
  const [clipboardError, setClipboardError] = useState(false); // Track if clipboard access was denied
  const [clipboardText, setClipboardText] = useState(""); // Track pasted text for verification
  const [micFeedback, setMicFeedback] = useState(null);
  const [micTestPassed, setMicTestPassed] = useState(false);
  const [isRecognizerRestarting, setIsRecognizerRestarting] = useState(false); // New state for UX
  const [interimTranscript, setInterimTranscript] = useState("");
  const [micManualFeedback, setMicManualFeedback] = useState(null); // null, 'yes', or 'no'

  // New state variables to track when actions are completed
  const [cameraActionCompleted, setCameraActionCompleted] = useState(false);
  const [internetActionCompleted, setInternetActionCompleted] = useState(false);
  const [speakerActionCompleted, setSpeakerActionCompleted] = useState(false);
  const [micActionCompleted, setMicActionCompleted] = useState(false);
  const [isCameraAccessDone, setIsCameraAccessDone] = useState(false);
  const [isCameraAccessDenied, setIsCameraAccessDenied] = useState(false);
  const [clipboardActionCompleted, setClipboardActionCompleted] =
    useState(false);
  const [isMicAccessDenied, setIsMicAccessDenied] = useState(false); // NEW STATE
  const [micPermission, setMicPermission] = useState("pending"); // "pending" | "granted" | "denied"
  const [clipboardPermission, setClipboardPermission] = useState("pending"); // "pending" | "granted" | "denied"

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  // Function to collect all test results
  const collectTestResults = () => {
    return {
      camera: cameraFeedback === "yes" || false,
      mic: (micManualFeedback === "yes" && micMatchPercent >= 60) || false,
      speaker: speakerHeard === "yes" || false,
      internet: averageSpeed ? parseFloat(averageSpeed) * 1000 : 0, // Convert to kbps
      clipboard: clipboardAccess || false,
      acceptance: isChecked || false,
    };
  };

  // Function to handle completion of test media
  const handleTestMediaCompletion = async () => {
    try {
      // Only collect and store metrics if not opened through settings
      if (!openingThroughSettings) {
        const testResults = collectTestResults();
        const metricsId = await collectAndStoreMetrics(testResults);

        // Store metricsId in localStorage for use in interview
        if (metricsId) {
          localStorage.setItem("interviewMetricsId", metricsId);
          console.log("System metrics stored successfully with ID:", metricsId);
        } else {
          console.warn("Failed to store system metrics");
        }
      }

      // Close the popup
      PopupStore.setTestMedia(false);
      handleTestCompleted();
    } catch (error) {
      console.error("Error completing test media:", error);
      // Still close the popup even if metrics storage fails
      PopupStore.setTestMedia(false);
      handleTestCompleted();
    }
  };

  useEffect(() => {
    if (openingThroughSettings) {
      setStep(0);
      setMaxStep(0);
      setCameraFeedback(null);
      setCameraActionCompleted(false);
      setIsCameraOn(false);
      setCameraStream(null);
      setInternetFeedback(null);
      setInternetActionCompleted(false);
      setInternetSpeeds([]);
      setAverageSpeed(null);
      setIsRunning(false);
      setSpeakerFeedback(null);
      setSpeakerHeard(null);
      setSpeakerManualFeedback(null);
      setSpeakerActionCompleted(false);
      setAudioPlayed(false);
      setPlaying(false);
      setMicFeedback(null);
      setMicManualFeedback(null);
      setMicActionCompleted(false);
      setIsUnMuted(false);
      setIsListening(false);
      setTranscriptArr([]);
      setInterimTranscript("");
      setMicTestPassed(false);
      setIsRecognizerRestarting(false);
      setClipboardAccess(false);
      setClipboardError(false);
      setClipboardText("");
      setClipboardActionCompleted(false);
      setIsChecked(false);
      setIsCameraAccessDone(false);
      setIsCameraOn(false);
      setIsCameraAccessDenied(false);
      setIsMicAccessDenied(false); // reset on settings open
      setClipboardPermission("pending");
    }
  }, [openingThroughSettings]);

  useEffect(() => {
    speechConfig.current = sdk.SpeechConfig.fromSubscription(
      SPEECH_KEY,
      REACT_APP_SPEECH_REGION
    );
    console.log("this is the region", REACT_APP_SPEECH_REGION);
    speechConfig.current.speechRecognitionLanguage = "en-IN";

    audioConfig.current = sdk.AudioConfig.fromDefaultMicrophoneInput();
    recognizer.current = new sdk.SpeechRecognizer(
      speechConfig.current,
      audioConfig.current
    );

    const processRecognizedTranscript = (event) => {
      const result = event.result;
      if (result.reason === sdk.ResultReason.RecognizedSpeech) {
        const newText = removeCharInSetence(result.text, ".");
        setTranscriptArr((prev) => {
          if (newText && (!prev.length || prev[prev.length - 1] !== newText)) {
            return [...prev, newText];
          }
          return prev;
        });
        setInterimTranscript("");
      }
    };

    const processRecognizingTranscript = (event) => {
      const result = event.result;
      if (result.reason === sdk.ResultReason.RecognizingSpeech) {
        setInterimTranscript(result.text);
      }
    };

    recognizer.current.recognized = (s, e) => processRecognizedTranscript(e);
    recognizer.current.recognizing = (s, e) => processRecognizingTranscript(e);

    // Auto-resume logic: if recognition session stops or is canceled, restart if still listening
    recognizer.current.sessionStopped = () => {
      if (isListeningRef.current) {
        setIsRecognizerRestarting(true);
        recognizer.current.startContinuousRecognitionAsync(() => {
          setIsRecognizerRestarting(false);
        });
      }
    };
    recognizer.current.canceled = () => {
      if (isListeningRef.current) {
        setIsRecognizerRestarting(true);
        recognizer.current.startContinuousRecognitionAsync(() => {
          setIsRecognizerRestarting(false);
        });
      }
    };

    return () => {
      recognizer.current.stopContinuousRecognitionAsync(() => {
        setIsListening(false);
      });
    };
  }, []);

  const resumeListening = () => {
    setIsListening(true);
    recognizer.current.startContinuousRecognitionAsync(() => {
      console.log("Resumed listening...");
    });
  };

  const stopListening = () => {
    setIsListening(false);
    recognizer.current.stopContinuousRecognitionAsync(() => {
      console.log("Speech recognition stopped.");
    });
  };

  useEffect(() => {
    if (isListening) {
      resumeListening();
    } else if (!isListening) {
      stopListening();
    }
  }, [isListening]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setMobileView(true);
    }
  }, []);

  const {
    error,
    interimResult,
    isRecording,
    results,
    startSpeechToText,
    stopSpeechToText,
  } = useSpeechToText({
    continuous: true,
    useLegacyResults: false,
  });

  speech
    .init({
      volume: 1,
      lang: "en-US",
      rate: 1,
      pitch: 1,
      // voice: "Google UK English Female",
      // splitSentences: true,
      listeners: {
        onvoiceschanged: (voices) => {
          // console.log("Event voiceschanged", voices);
        },
      },
    })
    .then((data) => {
      // The "data" object contains the list of available voices and the voice synthesis params
      // console.log("Speech is ready, voices are available", data);
    })
    .catch((e) => {
      console.error("An error occured while initializing : ", e);
    });

  const name = UserStore?.userDetails?.name ?? "Virat";
  const voiceId = JSON.parse(localStorage.getItem("customSettings"))?.find(
    (setting) => setting.name === "aiVoice"
  )?.value;

  const text = ` Hi! i am ${
    audioOptions.find((option) => option.id === voiceId)?.label ?? "lucy"
  } Your interviewer`;

  const speak = ({ text }) => {
    InterviewStore.setbotCC(text);
    const count = text?.length;

    const enableBackupAzureSpeechKey =
      process.env.REACT_APP_ENABLE_BACKUP_AZURE_SPEECH_KEY;
    // alert(enableBackupAzureSpeechKey);

    if (voiceId) {
      const voice = audioOptions.find((option) => option.id === voiceId)?.voice;
      InterviewStore.voiceSlang = voice;
    } else {
      InterviewStore.voiceSlang = JSON.parse(
        localStorage.getItem("Avatar")
      )?.voice;
    }

    const speechKey =
      enableBackupAzureSpeechKey === "true"
        ? process.env.REACT_APP_BACKUP_AZURE_SPEECH_KEY
        : process.env.REACT_APP_AZURE_SPEECH_KEY;
    // alert(speechKey, process.env.REACT_APP_ENABLE_BACKUP_AZURE_SPEECH_KEY);

    const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
      speechKey,
      process.env.REACT_APP_SPEECH_REGION ?? "centralindia"
    );
    console.log("this is the region", process.env.REACT_APP_SPEECH_REGION);
    const newSynthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig);

    // Adjust the speech speed using prosody rate
    const ssmlText = `
      <speak version="1.0" xmlns="http://www.w3.org/2001/10/synthesis" xml:lang="en-US">
        <voice name="${InterviewStore.voiceSlang}">
          <prosody rate="${-5.0}">
            ${text}
          </prosody>
        </voice>
      </speak>
    `;

    const speakSsmlAsyncPromise = (ssmlText) => {
      let settled = false;
      return new Promise((resolve, reject) => {
        newSynthesizer.speakSsmlAsync(
          ssmlText,
          (result) => {
            if (settled) return;
            if (
              result.reason ===
              SpeechSDK.ResultReason.SynthesizingAudioCompleted
            ) {
              settled = true;
              resolve(result);
            } else if (result.reason === SpeechSDK.ResultReason.Canceled) {
              settled = true;
              reject(new Error(result.errorDetails));
            }
            newSynthesizer.close();
          },
          (err) => {
            if (settled) return;
            settled = true;
            reject(err);
            newSynthesizer.close();
          }
        );
      });
    };
    setSpeaking(true);

    return speakSsmlAsyncPromise(ssmlText)
      .then((result) => {
        console.log("Speech synthesized to speaker for text [" + text + "]");
        setTimeout(() => {
          setSpeaking(false);
          // alert("speech ended");
          if (
            !InterviewStore.isInterviewCompleted &&
            text !== "Please say something"
          ) {
          }
          InterviewStore.setSpeechResult([]);
        }, count * 100 * 0.58 + 1000);
      })
      .catch((err) => {
        console.log("CANCELED: Reason=" + err.message);
        setSpeaking(false);

        InterviewStore.setSpeechResult([]);
      });
  };

  const speak2 = ({ text }) => {
    // InterviewStore.setbotCC(text);
    console.log("speak");
    return speech
      .speak({
        text: text,
        queue: false,
        listeners: {
          onstart: () => {
            console.log("Speak started");
            setSpeaking(true);
            // console.log('these are the voices' + text);
          },
          onend: () => {
            console.log("Speak ended"); // reset the speech result
          },
        },
      })
      .then(() => {
        console.log("Success !");
        console.log("End of speech");
        setSpeaking(false);
        return true;
      })
      .catch((e) => {
        console.error("An error occurred :", e);
        setSpeaking(false);
        throw e;
      });
  };

  const requestMicPermission = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicPermission("granted");
      setIsMicAccessDenied(false);
    } catch (error) {
      setMicPermission("denied");
      setIsMicAccessDenied(true);
    }
  };

  const start = async () => {
    setIsUnMuted(true);
    setTranscriptArr([]);
    setInterimTranscript("");
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setIsListening(true);
      setTimeout(() => {
        setMicActionCompleted(true);
      }, 2000);
      setIsMicAccessDenied(false); // reset on success
      setMicPermission("granted");
      console.log(interimResult);
    } catch (error) {
      alert(
        "Error accessing your microphone, please check your microphone settings"
      );
      setMicActionCompleted(true);
      setIsMicAccessDenied(true); // set on error
      setMicPermission("denied");
    }
    // setIsUnmuted(false);
  };

  const stop = () => {
    setIsListening(false);
    setIsUnMuted(false);
  };

  const handleStartVideo = async () => {
    try {
      setIsCameraOn(true);
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraStream(stream); // Store the stream
      // videoRef.current.srcObject = stream; // <-- Remove this line
      // videoRef.current.style.transform = "scaleX(-1)"; // Mirror the video horizontally
      setIsCameraAccessDone(true);
      // Add delay before showing feedback question
      setTimeout(() => {
        setCameraActionCompleted(true); // Mark camera action as completed after delay
      }, 2000); // 2 second delay
    } catch (error) {
      setIsCameraOn(false);
      setIsCameraAccessDone(false);
      setIsCameraAccessDenied(true);
      console.error("Error accessing camera:", error);
      alert("Error accessing your camera, please check your camera settings");

      setCameraActionCompleted(true); // Show feedback question even if permission denied
    }
  };

  // Add useEffect to set videoRef.current.srcObject when cameraStream and videoRef are ready
  useEffect(() => {
    if (isCameraOn && isCameraAccessDone && cameraStream && videoRef.current) {
      videoRef.current.srcObject = cameraStream;
      videoRef.current.style.transform = "scaleX(-1)"; // Mirror the video horizontally
    }
  }, [isCameraOn, isCameraAccessDone, cameraStream]);

  const handleStopVideo = () => {
    setIsCameraOn(false);
    if (cameraStream) {
      cameraStream.getTracks().forEach((track) => track.stop());
      setCameraStream(null);
    }
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const closeThisPopUP = () => {
    handlePopUp();
  };

  // Add skip function to skip entire media testing
  const skipMediaTesting = () => {
    // Clean up any active processes
    if (isListening) {
      stopListening();
    }
    if (isCameraOn) {
      handleStopVideo();
    }
    if (playing) {
      setPlaying(false);
    }

    // Close the popup
    handlePopUp();
  };

  const microphoneResult = () => {
    try {
      if (mobileView) {
        console.log(results[results.length - 1]?.transcript);
        return results[results.length - 1]?.transcript;
      } else {
        return interimResult;
      }
    } catch (error) {
      console.log(error);
      return "No result";
    }
  };

  const [internetSpeeds, setInternetSpeeds] = useState([]);
  const [averageSpeed, setAverageSpeed] = useState(null);
  const [isRunning, setIsRunning] = useState(false);

  const getInternetSpeed = async () => {
    const startTime = Date.now();
    const img = new Image();
    img.src = "https://picsum.photos/1024/768"; // Use a larger known image size
    img.onload = () => {
      const endTime = Date.now();
      const elapsedTime = endTime - startTime;
      if (elapsedTime > 0) {
        const imageSize = 1024 * 768 * 3; // Approximate size in bytes for a 1024x768 image
        const speedInBytesPerSecond = imageSize / elapsedTime;
        const speedInKbps = (speedInBytesPerSecond * 8) / 1024;
        const speedInMbps = speedInKbps / 1000; // Convert kbps to Mbps
        setInternetSpeeds((prevSpeeds) => [...prevSpeeds, speedInMbps]);
        setSpeedHistory((prev) => {
          const newArr = [...prev, speedInKbps];
          return newArr.length > 10 ? newArr.slice(newArr.length - 10) : newArr;
        });
      }
    };
  };

  useEffect(() => {
    if (isRunning) {
      const intervalId = setInterval(getInternetSpeed, 500); // Run every 1 second
      const timeoutId = setTimeout(() => {
        clearInterval(intervalId);
        setIsRunning(false); // Stop the test after 30 seconds
      }, 30000); // Stop after 30 seconds

      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }
  }, [isRunning]);

  useEffect(() => {
    if (internetSpeeds.length > 0) {
      const sum = internetSpeeds.reduce((a, b) => a + b, 0);
      const average = sum / internetSpeeds.length;
      setAverageSpeed(`${average.toFixed(2)}`);
    }
  }, [internetSpeeds]);

  const startSpeedTest = () => {
    setIsRunning(true);
    // Add delay before showing feedback question
    setTimeout(() => {
      setInternetActionCompleted(true); // Mark internet action as completed after delay
    }, 2000); // 2 second delay
  };

  const stopSpeedTest = () => {
    setIsRunning(false);
  };

  // Check clipboard permissions and access
  const checkClipboardAccess = async () => {
    try {
      if (!navigator.clipboard) {
        setClipboardAccess(false);
        setClipboardError(true);
        setClipboardPermission("denied");
        return;
      }
      const testText = "ClipboardTest_" + Date.now();
      try {
        await navigator.clipboard.writeText(testText);
        const readText = await navigator.clipboard.readText();
        if (readText === testText) {
          setClipboardAccess(true);
          setClipboardError(false);
          setClipboardPermission("granted");
          return;
        } else {
          setClipboardAccess(false);
          setClipboardError(true);
          setClipboardPermission("denied");
          return;
        }
      } catch (writeError) {
        setClipboardAccess(false);
        setClipboardError(true);
        setClipboardPermission("denied");
        return;
      }
    } catch (error) {
      setClipboardAccess(false);
      setClipboardError(true);
      setClipboardPermission("denied");
      return;
    }
  };

  // When moving forward, update maxStep
  const goToStep = (idx) => {
    if (step === 4) {
      setTranscriptArr([]);
      setSpeakerFeedback(null);
    }
    setStep(idx);
    setMaxStep((prev) => (idx > prev ? idx : prev));
    setInterimTranscript("");
  };

  const micMatchPercent = getMicTestMatchPercent(
    micTestReference,
    transcriptArr.join(" ") || interimTranscript
  );

  useEffect(() => {
    if (micMatchPercent >= 50 && !micTestPassed) {
      setMicTestPassed(true);
    }
  }, [micMatchPercent, micTestPassed]);
  //add  use effect to disable the camera button if the camera is on

  useEffect(() => {
    isListeningRef.current = isListening;
  }, [isListening]);

  // Restore camera stream when navigating back to camera step
  useEffect(() => {
    if (step === 1 && isCameraOn && cameraStream && videoRef.current) {
      videoRef.current.srcObject = cameraStream;
      videoRef.current.style.transform = "scaleX(-1)"; // Mirror the video horizontally
    }
  }, [step, isCameraOn, cameraStream]);

  return (
    <Observer>
      {() => (
        <>
          {popUPInitialValue ? (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm">
              <div
                onClick={(e) => e.stopPropagation()}
                className="relative w-full max-w-3xl mx-auto bg-white rounded-lg shadow-2xl flex flex-col"
                style={{
                  height: "650px",
                  minHeight: "600px",
                  maxHeight: "700px",
                }}
              >
               {openingThroughSettings ?
                <button
                  onClick={() => {
                    closeThisPopUP();
                  }}
                  className="absolute top-4 right-4 bg-white rounded-full p-2 cursor-pointer hover:bg-gray-100 transition-colors duration-200 z-50"
                >
                  <IoClose className="text-2xl text-gray-600" />
                </button> 
                : null}
                <div className="flex-1 flex flex-col  px-8 py-6">
                  {/* Step Progress Bar and Content Container */}
                  <div className="max-w-xl mx-auto w-full">
                    {/* Step Progress Bar */}
                    <div className="mb-2">
                      <div className="text-base font-medium text-gray-800 mb-1">
                        Step {step + 1} of {steps.length}
                      </div>
                      <div className="w-full h-2 bg-[#F3E9E1] rounded-full mb-4">
                        <div
                          className="h-2 bg-[#FF7900] rounded-full transition-all duration-500"
                          style={{
                            width: `${((step + 1) / steps.length) * 100}%`,
                          }}
                        ></div>
                      </div>
                    </div>
                    {/* Step Content */}
                    {step === 0 && (
                      <>
                        <div className="text-2xl font-bold text-gray-900 mb-3">
                          Welcome to the Media Device Tester
                        </div>
                        <div className="text-base text-gray-700 mb-4">
                          This application will guide you through a series of
                          tests to ensure your media device is functioning
                          correctly. Follow the on-screen instructions carefully
                          to complete each step. The process includes checks for
                          audio, video, and connectivity. Click 'Next' to begin
                          the testing process.
                        </div>
                      </>
                    )}
                    {/* Step 1: Camera */}
                    {step === 1 && (
                      <>
                        <div className="text-2xl font-bold text-gray-900 ">
                          Camera Test
                        </div>
                        <div className="text-base text-gray-700 mb-2">
                          Enable your camera and check if it is working
                          correctly.
                        </div>
                        <div className="flex flex-col w-full items-center">
                          <div className="w-full h-60 bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden mb-4">
                            {isCameraAccessDenied && !isCameraOn ? (
                              <video
                                src={video2}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                loop
                                playsInline
                              />
                            ) : !isCameraOn ? (
                              <video
                                src={video}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                loop
                                playsInline
                              />
                            ) : isCameraAccessDone && isCameraOn ? (
                              <video
                                ref={videoRef}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                playsInline
                                style={{ transform: "scaleX(-1)" }}
                              />
                            ) : null}
                          </div>
                        </div>
                        {!isCameraAccessDone ? (
                          <div className="w-full mb-4 flex items-center justify-center">
                            <button
                              onClick={handleStartVideo}
                              className="flex flex-col items-center justify-center px-6 py-2 rounded-lg  text-white gil-reg bg-primary "
                            >
                              <span className="text-base">
                                Request Permission
                              </span>
                            </button>
                          </div>
                        ) : null}

                        {/* Camera feedback (step 1) */}
                        {cameraActionCompleted && (
                          <div className="w-full">
                            <div className="text-base font-semibold">
                              Is your camera working correctly?
                            </div>
                            <RadioGroup.Root
                              value={cameraFeedback || ""}
                              onValueChange={setCameraFeedback}
                              className="flex flex-row gap-4 mt-2"
                              color="orange"
                            >
                              <RadioGroup.Item value="yes">Yes</RadioGroup.Item>
                              <RadioGroup.Item value="no">No</RadioGroup.Item>
                            </RadioGroup.Root>
                            {cameraFeedback === "no" && (
                              <div className="mt-1">
                                <p className=" text-sm text-red-600 font-medium">
                                  Please check your camera settings and
                                  permissions.
                                </p>
                                {/* Camera checklist */}
                                <ul className=" text-sm text-gray-700 list-disc pl-5">
                                  <li>
                                    Check browser permissions for camera access.
                                  </li>
                                  <li>
                                    Close other apps that might be using the
                                    camera.
                                  </li>
                                  <li>
                                    If using an external webcam, ensure it is
                                    plugged in.
                                  </li>
                                </ul>
                                <span
                                  className="text-gray-400 text-sm cursor-pointer ml-2"
                                  onClick={() => goToStep(step + 1)}
                                >
                                  Skip for now
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                    {/* Step 2: Internet */}
                    {step === 2 && (
                      <>
                        <div className="text-2xl font-bold text-gray-900 mb-4">
                          Internet Speed Test
                        </div>
                        <div className="text-base text-gray-700 mb-3">
                          Test your connection quality. Click start to begin the
                          speed test. (min{" "}
                          <span className="text-primary">500 kbps</span> speed
                          is required)
                        </div>
                        <div className="flex flex-row gap-8 w-full mb-6">
                          <div className="flex-1 bg-[#F9F6F3] rounded-xl p-6 flex flex-col items-center border border-gray-200">
                            <div className="text-sm text-gray-500 mb-1">
                              Download Speed
                            </div>
                            <div className="text-2xl font-bold text-gray-900">
                              {averageSpeed ? averageSpeed : "--"} Mbps
                            </div>
                          </div>
                          {/* Optionally add upload speed if available */}
                        </div>
                        <div className="w-full mb-4">
                          <button
                            onClick={isRunning ? stopSpeedTest : startSpeedTest}
                            className={`px-8 py-3 rounded-lg font-medium ${
                              isRunning
                                ? "bg-red-500 text-white"
                                : "bg-[#FF7900] text-white"
                            }`}
                          >
                            {isRunning ? "Stop" : "Check Speed"}
                          </button>
                        </div>
                        {internetActionCompleted && (
                          <div className="w-full mb-4">
                            <div className="text-base font-semibold mb-2">
                              Is your internet speed sufficient for your needs?
                            </div>
                            <RadioGroup.Root
                              value={internetFeedback || ""}
                              onValueChange={setInternetFeedback}
                              className="flex flex-row gap-4 mt-2"
                              color="orange"
                            >
                              <RadioGroup.Item value="yes">Yes</RadioGroup.Item>
                              <RadioGroup.Item value="no">No</RadioGroup.Item>
                            </RadioGroup.Root>
                            {internetFeedback === "no" && (
                              <div className="mt-1">
                                <p className=" text-sm text-red-600 font-medium">
                                  Please check your internet connection or try a
                                  different network.
                                </p>
                                {/* Internet checklist */}
                                <ul className=" text-sm text-gray-700 list-disc pl-5">
                                  <li>
                                    Ensure you are connected to a stable Wi-Fi
                                    or wired network.
                                  </li>
                                  <li>
                                    Close unnecessary apps or tabs using the
                                    internet.
                                  </li>
                                  <li>
                                    Pause any large downloads or streaming
                                    services.
                                  </li>
                                </ul>
                                <span
                                  className="text-gray-400 text-sm cursor-pointer ml-2"
                                  onClick={() => goToStep(step + 1)}
                                >
                                  Skip for now
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                    {/* Step 3: Speaker */}
                    {step === 3 && (
                      <>
                        <div className="text-2xl font-bold text-gray-900 mb-4">
                          Test your speakers
                        </div>
                        <div className="text-base text-gray-700 mb-3">
                          Click the button below to play a test sound. Then,
                          answer the feedback question.
                        </div>
                        <div className="w-full mb-4 flex flex-col items-center">
                          <button
                            onClick={async () => {
                              console.log("Play Test Sound button clicked");
                              setPlaying(true);
                              const play = async () => {
                                try {
                                  const speechFunction =
                                    process.env.REACT_APP_AZURE_VOICE === "true"
                                      ? speak
                                      : speak2;
                                  console.log(
                                    "Using speech function:",
                                    process.env.REACT_APP_AZURE_VOICE === "true"
                                      ? "Azure"
                                      : "Browser TTS"
                                  );
                                  await speechFunction({ text });
                                } catch (error) {
                                  console.error("Error during speech:", error);
                                  setPlaying(false);
                                }
                              };
                              setTimeout(() => {
                                setPlaying(false);
                                setAudioPlayed(true);
                                // Add delay before showing feedback question
                                setTimeout(() => {
                                  setSpeakerActionCompleted(true); // Mark speaker action as completed after delay
                                }, 2000); // 2 second delay after audio finishes
                              }, 3000);
                              await play();
                            }}
                            className={`px-8 py-3 rounded-lg font-medium ${
                              playing
                                ? "bg-gray-400 text-white cursor-not-allowed"
                                : "bg-[#FF7900] text-white"
                            }`}
                            disabled={playing}
                          >
                            {playing ? "Playing..." : "Play Test Sound"}
                          </button>
                        </div>
                        {speakerActionCompleted && (
                          <div className="w-full mb-4">
                            {speakerHeard === null && (
                              <>
                                <div className="text-base font-semibold mb-2">
                                  Did you hear the test sound?
                                </div>
                                <RadioGroup.Root
                                  value={speakerHeard || ""}
                                  onValueChange={setSpeakerHeard}
                                  className="flex flex-row gap-6 mb-2 items-center min-h-[40px]"
                                  color="orange"
                                >
                                  <RadioGroup.Item value="yes">
                                    Yes
                                  </RadioGroup.Item>
                                  <RadioGroup.Item value="no">
                                    No
                                  </RadioGroup.Item>
                                </RadioGroup.Root>
                              </>
                            )}
                            {speakerHeard === "yes" && (
                              <div className="flex flex-col gap-2 w-full mt-3">
                                <div className="text-base font-semibold mb-2">
                                  How was the sound quality?
                                </div>
                                <RadioGroup.Root
                                  value={speakerFeedback || ""}
                                  onValueChange={setSpeakerFeedback}
                                  className="flex flex-col gap-2"
                                  color="orange"
                                >
                                  {[
                                    "Sound quality is excellent",
                                    "Sound quality is good",
                                    "Sound quality is fair",
                                    "Sound quality is poor",
                                  ].map((label) => (
                                    <RadioGroup.Item
                                      key={label}
                                      value={label}
                                      className="flex items-center gap-3 cursor-pointer w-full px-6 py-4 rounded-xl border transition-colors duration-150 data-[state=checked]:border-[#FF6B00] data-[state=checked]:bg-[#FFF5EC] border-[#FFE5D0] bg-white"
                                      style={{ minHeight: "48px" }}
                                    >
                                      <span className="font-medium text-base">
                                        {label}
                                      </span>
                                    </RadioGroup.Item>
                                  ))}
                                </RadioGroup.Root>
                              </div>
                            )}
                            {speakerHeard === "no" && (
                              <>
                                <div className="text-base font-semibold mb-2">
                                  Did you hear the test sound?
                                </div>
                                <RadioGroup.Root
                                  value={speakerHeard || ""}
                                  onValueChange={setSpeakerHeard}
                                  className="flex flex-row gap-6 mb-2 items-center min-h-[40px]"
                                  color="orange"
                                >
                                  <RadioGroup.Item value="yes">
                                    Yes
                                  </RadioGroup.Item>
                                  <RadioGroup.Item value="no">
                                    No
                                  </RadioGroup.Item>
                                </RadioGroup.Root>
                                <div className="w-full mt-3">
                                  <p className="text-sm text-red-600 font-medium">
                                    Please check your speakers and try again.
                                  </p>
                                  {/* Speaker checklist */}
                                  <ul className="mb-2 text-sm text-gray-700 mt-2 list-disc pl-5">
                                    <li>
                                      Check your system volume is turned up.
                                    </li>
                                    <li>
                                      If you’re using earphones/headphones,
                                      ensure they are connected properly.
                                    </li>
                                    <li>Make sure your device is not muted.</li>
                                  </ul>
                                  <span
                                    className="text-gray-400 text-sm cursor-pointer ml-2"
                                    onClick={() => goToStep(step + 1)}
                                  >
                                    Skip for now
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </>
                    )}
                    {/* Step 4: Mic */}
                    {step === 4 && (
                      <>
                        <div className="text-2xl font-bold text-gray-900 mb-4">
                          Test your microphone
                        </div>
                        <div className="text-base text-gray-700 mb-3">
                          Please read the following sentence aloud to test your
                          microphone:
                        </div>
                        {/* Microphone permission logic */}
                        {micPermission === "pending" && (
                          <div className="flex flex-col w-full items-center mb-6">
                            <div className="w-full h-64 bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden mb-4">
                              <video
                                src={video}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                loop
                                playsInline
                              />
                            </div>
                            <button
                              className="px-8 py-3 rounded-lg font-medium bg-[#FF7900] text-white"
                              onClick={requestMicPermission}
                            >
                              Request Permission
                            </button>
                          </div>
                        )}
                        {micPermission === "denied" && (
                          <div className="flex flex-col w-full items-center mb-6">
                            <div className="w-full h-64 bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden mb-4">
                              <video
                                src={video2}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                loop
                                playsInline
                              />
                            </div>
                            <div className="text-base text-red-600 font-semibold mb-2 text-center">
                              Microphone access was denied. Please enable
                              microphone access in your browser settings and try
                              again.
                            </div>
                            <button
                              className="px-8 py-3 rounded-lg font-medium bg-[#FF7900] text-white"
                              onClick={requestMicPermission}
                            >
                              Try Again
                            </button>
                          </div>
                        )}
                        {micPermission === "granted" && (
                          <>
                            {/* Show indicator if recognizer is restarting */}
                            {isRecognizerRestarting && (
                              <div className="mb-2 text-orange-600 font-semibold flex items-center gap-2">
                                <svg
                                  className="animate-spin h-5 w-5 text-orange-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                Listening paused, resuming...
                              </div>
                            )}
                            <div className="bg-gray-100 rounded p-4 mb-4 font-mono text-2xl text-primary flex flex-wrap gap-1">
                              {getMicTestProgress(
                                micTestReference,
                                transcriptArr.join(" ") || interimTranscript
                              ).map(({ word, matched }, idx) => (
                                <span
                                  key={idx}
                                  className={
                                    matched ? "font-bold" : "text-gray-500"
                                  }
                                  style={{
                                    color: matched ? "primary" : undefined,
                                    transition: "color 0.2s, font-weight 0.2s",
                                  }}
                                >
                                  {word}
                                </span>
                              ))}
                            </div>
                            <div className="w-full mb-4 flex flex-col items-start">
                              {isUnmuted && micMatchPercent === 100 ? (
                                <button
                                  className="px-8 py-3 rounded-lg font-medium mb-4 bg-red-500 text-white opacity-50 cursor-not-allowed"
                                  disabled
                                >
                                  Stop Recording
                                </button>
                              ) : (
                                <button
                                  onClick={isUnmuted ? stop : start}
                                  className={`px-8 py-3 rounded-lg font-medium mb-4 ${
                                    isUnmuted
                                      ? "bg-red-500 text-white"
                                      : "bg-[#FF7900] text-white"
                                  }`}
                                  disabled={
                                    isUnmuted && micMatchPercent === 100
                                  }
                                >
                                  {isUnmuted
                                    ? "Stop Recording"
                                    : "Start Recording"}
                                </button>
                              )}
                            </div>
                            {/* Microphone feedback logic */}
                            {micActionCompleted && (
                              <div className="w-full mb-4">
                                <div className="text-base font-semibold mb-2">
                                  Is your microphone working correctly?
                                </div>
                                <RadioGroup.Root
                                  value={micManualFeedback || ""}
                                  onValueChange={setMicManualFeedback}
                                  className="flex flex-row gap-4 mb-4"
                                  color="orange"
                                >
                                  <RadioGroup.Item value="yes">
                                    Yes
                                  </RadioGroup.Item>
                                  <RadioGroup.Item value="no">
                                    No
                                  </RadioGroup.Item>
                                </RadioGroup.Root>
                                {micManualFeedback === "yes" && (
                                  <>
                                    <div className="text-base font-semibold mb-2">
                                      How did your microphone perform?
                                    </div>
                                    <div className="flex flex-row gap-4 flex-wrap">
                                      {[
                                        "Excellent",
                                        "Good",
                                        "Fair",
                                        "Poor",
                                      ].map((label) => (
                                        <button
                                          key={label}
                                          type="button"
                                          className={`feedback-pill px-4 py-1 min-w-[120px] text-base ${
                                            micFeedback === label
                                              ? " selected"
                                              : ""
                                          }`}
                                          onClick={() => setMicFeedback(label)}
                                        >
                                          {label}
                                        </button>
                                      ))}
                                    </div>
                                  </>
                                )}
                                {micManualFeedback === "no" && (
                                  <div className="w-full mt-1">
                                    <p className="text-sm text-red-600 font-medium">
                                      Please check your microphone and try
                                      again.
                                    </p>
                                    {/* Microphone checklist */}
                                    <ul className=" text-sm text-gray-700 list-disc pl-5">
                                      <li>
                                        Make sure your microphone is connected.
                                      </li>
                                      <li>
                                        If using an external mic, ensure it is
                                        plugged in.
                                      </li>
                                      <li>
                                        Check browser permissions for microphone
                                        access.
                                      </li>
                                      <li>
                                        Close other apps that might be using the
                                        microphone.
                                      </li>
                                    </ul>
                                    <span
                                      className="text-gray-400 text-sm cursor-pointer ml-2"
                                      onClick={() => goToStep(step + 1)}
                                    >
                                      Skip for now
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {/* Step 5: Clipboard */}
                    {step === 5 && (
                      <div className="w-full flex flex-col items-start">
                        <div className="text-2xl font-bold text-gray-900 mb-4">
                          Test your clipboard
                        </div>
                        {/* Clipboard video logic */}
                        {clipboardPermission === "pending" && (
                          <div className="w-full flex flex-col items-center mb-4">
                        <div className="text-base text-gray-700 mb-3">
                          Click the button below to check clipboard access.
                        </div>
                            <div className="w-full h-64 bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden mb-4">
                              <video
                                src={clipboardVideo2}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                loop
                                playsInline
                                muted
                              />
                            </div>
                            <button
                              className="px-6 py-3 bg-[#FF7900] text-white rounded-lg font-medium mb-4"
                              onClick={checkClipboardAccess}
                              disabled={clipboardAccess}
                            >
                              Allow access
                            </button>
                          </div>
                        )}
                        {clipboardPermission === "denied" && (
                          <div className="w-full flex flex-col items-center mb-4">
                            <div className="w-full h-64 bg-gray-200 rounded-xl flex items-center justify-center overflow-hidden mb-4">
                              <video
                                src={clipboardVideo}
                                className="rounded-lg w-full h-full object-cover"
                                autoPlay
                                loop
                                playsInline
                                muted
                              />
                            </div>
                            <div className="text-sm text-red-600 font-medium mt-2 mb-2 text-center">
                              Clipboard access denied. Please enable clipboard
                              permissions in your browser settings.
                            </div>
                            <button
                              className="px-6 py-3 bg-[#FF7900] text-white rounded-lg font-medium mb-4"
                              onClick={() => setClipboardPermission("pending")}
                            >
                              Try Again
                            </button>
                          </div>
                        )}
                        {clipboardPermission === "granted" && (
                          <>
                            {/* Clipboard checklist */}
                            <ul className="mb-4 text-sm text-gray-700 list-disc pl-5">
                              <li>
                                Make sure your browser supports clipboard
                                access.
                              </li>
                              <li>If prompted, allow clipboard permissions.</li>
                              <li>
                                Try copying and pasting text manually if needed.
                              </li>
                            </ul>
                            {!clipboardAccess && clipboardError && (
                              <div className="text-sm text-red-600 font-medium mt-2">
                                Clipboard access denied. Please enable clipboard
                                permissions in your browser settings.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                    {/* Step 6: Summary/Consent */}
                    {step === 6 && (
                      <>
                        <div className="text-2xl font-bold text-gray-900 mb-4">
                          You're all set!
                        </div>
                        <div className="text-base text-gray-700 mb-3">
                          You have successfully completed all the setup steps.
                          Please review your details below before starting your
                          interview.
                        </div>
                        <ul className="w-full mb-4">
                          <li className="flex items-center mb-2">
                            <FaCheck className="text-[#FF7900] mr-2" /> Camera,
                            Internet, Speaker, and Mic tested
                          </li>
                          <li className="flex items-center mb-2">
                            <FaCheck className="text-[#FF7900] mr-2" />{" "}
                            Clipboard access granted
                          </li>
                          <li className="flex items-center">
                            <FaCheck className="text-[#FF7900] mr-2" /> Consent
                            given for evaluation
                          </li>
                        </ul>
                        <div className="flex items-center mb-4">
                          <input
                            className="accent-[#FF7900] scale-125 mr-2"
                            type="checkbox"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                            id="consent-checkbox"
                          />
                          <label
                            htmlFor="consent-checkbox"
                            className="text-sm text-gray-700 cursor-pointer"
                          >
                            I agree to the use of my video, audio, and
                            screenshots for evaluation purposes
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="w-full  flex flex-row justify-between px-8 pb-6 pt-2 bg-white rounded-b-lg">
                  {step === 0 ? (
                    <button
                      onClick={skipMediaTesting}
                      className="px-6 py-2 hover:bg-gray-500 text-gray-300 rounded-lg text-sm font-medium transition-colors duration-200"
                    >
                      Skip
                    </button>
                  ) : step > 0 ? (
                    <button
                      className="px-8 py-2 rounded-md bg-[#F3E9E1] text-gray-800 text-lg font-bold"
                      onClick={() => goToStep(step - 1)}
                    >
                      Previous
                    </button>
                  ) : null}
                  <div className="flex-1"></div>
                  {step < steps.length - 1 ? (
                    <button
                      className={`px-8 py-2 rounded-md text-white text-lg font-bold shadow-md transition-all duration-200 ${
                        (step === 1 &&
                          (!cameraActionCompleted ||
                            cameraFeedback !== "yes")) ||
                        (step === 2 &&
                          (!internetActionCompleted ||
                            !averageSpeed ||
                            parseFloat(averageSpeed) * 1000 < 500)) ||
                        (step === 3 &&
                          (!speakerActionCompleted ||
                            speakerHeard === null ||
                            (speakerHeard === "no" &&
                              speakerManualFeedback === null) ||
                            (speakerHeard === "no" &&
                              speakerManualFeedback === "no") ||
                            (speakerHeard === "yes" && !speakerFeedback) ||
                            (speakerHeard === "no" &&
                              speakerManualFeedback === "yes" &&
                              !speakerFeedback))) ||
                        (step === 4 && micMatchPercent < 60) ||
                        (step === 5 && !clipboardAccess)
                          ? "bg-gray-300 cursor-not-allowed"
                          : "bg-[#FF7900] hover:bg-orange-600 focus:ring-2 focus:ring-orange-300"
                      }`}
                      onClick={() => {
                        if (
                          (step === 1 &&
                            (!cameraActionCompleted ||
                              cameraFeedback !== "yes")) ||
                          (step === 2 &&
                            (!internetActionCompleted ||
                              !averageSpeed ||
                              parseFloat(averageSpeed) * 1000 < 500)) ||
                          (step === 3 &&
                            (!speakerActionCompleted ||
                              speakerHeard === null ||
                              (speakerHeard === "no" &&
                                speakerManualFeedback === null) ||
                              (speakerHeard === "no" &&
                                speakerManualFeedback === "no") ||
                              (speakerHeard === "yes" && !speakerFeedback) ||
                              (speakerHeard === "no" &&
                                speakerManualFeedback === "yes" &&
                                !speakerFeedback))) ||
                          (step === 4 && micMatchPercent < 60) ||
                          (step === 5 && !clipboardAccess)
                        )
                          return;
                        goToStep(step + 1);
                      }}
                      disabled={
                        (step === 1 &&
                          (!cameraActionCompleted ||
                            cameraFeedback !== "yes")) ||
                        (step === 2 &&
                          (!internetActionCompleted ||
                            !averageSpeed ||
                            parseFloat(averageSpeed) * 1000 < 500)) ||
                        (step === 3 &&
                          (!speakerActionCompleted ||
                            speakerHeard === null ||
                            (speakerHeard === "no" &&
                              speakerManualFeedback === null) ||
                            (speakerHeard === "no" &&
                              speakerManualFeedback === "no") ||
                            (speakerHeard === "yes" && !speakerFeedback) ||
                            (speakerHeard === "no" &&
                              speakerManualFeedback === "yes" &&
                              !speakerFeedback))) ||
                        (step === 4 && micMatchPercent < 60) ||
                        (step === 5 && !clipboardAccess)
                      }
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      className={`px-8 py-2 rounded-md text-white text-lg font-bold shadow-md transition-all duration-200 ${
                        isChecked
                          ? "bg-[#FF7900] hover:bg-orange-600 focus:ring-2 focus:ring-orange-300"
                          : "bg-gray-300 cursor-not-allowed"
                      }`}
                      disabled={!isChecked}
                      onClick={handleTestMediaCompletion}
                    >
                      Let's Start
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
    </Observer>
  );
}
